import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { handleClickoutUrl, isClickoutUrl, UrlHelper, trackClickout } from '@/helpers/clickout-helper';
import { ClickoutType } from '@/interfaces/snowplow/clickout-context';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClickoutAnchor',
  props: {
    href: null,
    rel: { default: 'noopener' },
    skipPreAffiliationCheck: { type: Boolean },
    clickoutType: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'click', event: MouseEvent): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { href: UrlHelper, rel: string, skipPreAffiliationCheck?: boolean, clickoutType?: ClickoutType };





const enableSkipUct = computed(() => false);

// The non-UCT, non-adblockable link that is allowed in the HTML.
// Fallback to the UCT link so that worst case there's still something.
const offerUrl = computed(() => {
	if (enableSkipUct.value) {
		if (isClickoutUrl(props.href) && props.href.preAffiliatedUrl) {
			return props.href.preAffiliatedUrl;
		}
		return props.href.get('r') ?? props.href.toString();
	}

	// return the directly affiliated link
	return props.href.toString();
});

function onClickout(event: MouseEvent) {
	emits('click', event);

	if (!enableSkipUct.value || !props.href) {
		if (isClickoutUrl(props.href)) {
			trackClickout(props.href);
		}
		return;
	}

	// Skip UCT is active, prevent default <a> behavior and take over with our `handleClickoutUrl` logic
	event.preventDefault();

	handleClickoutUrl(props.href, enableSkipUct.value, !props.skipPreAffiliationCheck);
}

return { __sfc: true,props, emits, enableSkipUct, offerUrl, onClickout }
}

})